module.exports = {"available":"Dostupno","booked":"Rezervisano","occupied":"Occupied","booked-occupied":"Rezervisano / Occupied","used":"used","until":"do","all-day":"cijeli dan","page_over_total":"Stranica {page} od {total}","room-name":"Ime sobe","current-booking":"Trenutno","next-booking":"Sledece","unknown":"NEPOZNATO","floors":"Sprat","today":"Danas","no_bookings":"Za danas nema ugovorenih sastanka","no_information":"Nema informacija","description":"Description","capacity":"Capacity","allocated":"Allocated","booked-occupied-allocated":"Rezervisano / Occupied / Allocated"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/hr.json
// module id = IHdd
// module chunks = 2